export { default } from "./withCreateSellerInquiry";
